import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-home-tile',
    templateUrl: './block-home-tile.component.html',
})

export class BlockHomeTileComponent extends BlockAbstractComponent implements OnInit {
    isStyle2?: boolean;
    isStyle4?: boolean;
    isStyle5?: boolean;
    isStyle6?: boolean;

    override ngOnInit() {
        this.isStyle2 = this.block.data.style === 'style2';
        this.isStyle4 = this.block.data.style === 'style4';
        this.isStyle5 = this.block.data.style === 'style5';
        this.isStyle6 = this.block.data.style === 'style6';
    }
}
